// src/components/filings/FilingRow.jsx
import React from 'react';
import { categoryStyle, significanceWeight } from '../../data/filingFieldRegistry';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Fire-and-forget D3 Tier 3 click signal — distinct from the automatic
// feed_view signal logged server-side on every GET /api/filings. Never
// blocks the actual navigation (SEC link opens regardless of this call's
// outcome — catch swallows silently, same discipline as signalWriter itself).
function logClick(filing) {
  fetch(API_URL + '/api/filings/interaction', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'click', ticker: filing.ticker, filingCategory: filing.filingCategory, tier: filing.tier }),
  }).catch(() => {});
}

export default function FilingRow({ filing, onNavigate }) {
  const style = categoryStyle(filing.filingCategory);
  const weight = significanceWeight(filing.significance);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: '1rem', padding: '0.9rem 1.1rem',
      background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)',
      borderRadius: '10px', marginBottom: '0.5rem', flexWrap: 'wrap',
    }}>
      <div style={{ width: 34, height: 34, borderRadius: '8px', flexShrink: 0,
        background: style.color + '18', border: '1px solid ' + style.color + '30',
        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem' }}>
        {style.icon}
      </div>

      <div style={{ flex: '1 1 220px', minWidth: 0 }}>
        <button onClick={() => onNavigate && onNavigate('stock', { ticker: filing.ticker })}
          style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer',
            fontSize: '0.9rem', fontWeight: 800, color: '#00d4ff', fontFamily: 'inherit' }}>
          {filing.ticker}
        </button>
        <div style={{ fontSize: '0.72rem', color: '#64748b', marginTop: '0.1rem',
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {filing.companyName || filing.ticker}
        </div>
      </div>

      <div style={{ flex: '1 1 180px', fontSize: '0.82rem', color: '#cbd5e1', fontWeight: 600 }}>
        {filing.filingLabel}
      </div>

      <div title={`Significance ${filing.significance}/10`}
        style={{ display: 'flex', gap: '2px', flex: '0 0 auto' }}>
        {Array.from({ length: 10 }).map((_, i) => (
          <div key={i} style={{
            width: 4, height: 12, borderRadius: '2px',
            background: i < weight.filled
              ? (weight.isHighConviction ? '#ff4444' : '#00d4ff')
              : 'rgba(255,255,255,0.08)',
          }} />
        ))}
      </div>

      <div style={{ fontSize: '0.72rem', color: '#475569', flex: '0 0 90px', textAlign: 'right' }}>
        {filing.filedAt}
      </div>

      {filing.secUrl && (
        <a href={filing.secUrl} target="_blank" rel="noopener noreferrer"
          onClick={() => logClick(filing)}
          style={{ fontSize: '0.75rem', fontWeight: 700, color: '#00ff88', textDecoration: 'none',
            padding: '0.35rem 0.75rem', border: '1px solid rgba(0,255,136,0.3)', borderRadius: '6px',
            whiteSpace: 'nowrap', flex: '0 0 auto' }}>
          View ↗
        </a>
      )}
    </div>
  );
}
